import { render } from "./DatasetCopyModal.vue?vue&type=template&id=043b349f&scoped=true"
import script from "./DatasetCopyModal.vue?vue&type=script&lang=js"
export * from "./DatasetCopyModal.vue?vue&type=script&lang=js"

import "./DatasetCopyModal.vue?vue&type=style&index=0&id=043b349f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-043b349f"]])

export default __exports__